module.exports = __webpack_public_path__ + "img/Wide-Belt_fr.d1920513.jpg";